import {
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import { Search } from "assets/Icon";

function SearchInput({ value, onChange }) {
  const theme = useTheme();
  return (
    <TextFieldStyle
      placeholder="Search Currency"
      variant="outlined"
      value={value}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment color="text.main" position="start">
            <IconButton aria-label="history" size="small">
              <Typography
                component="span"
                ml={1}
                display="flex"
                alignItems="center"
              >
                <Search color={theme.palette.text.main} />
              </Typography>
            </IconButton>
          </InputAdornment>
        ),
      }}
      fullWidth
    />
  );
}

const TextFieldStyle = styled(TextField)(({ theme }) => ({
  ".MuiInputBase-root": {
    borderRadius: "10px",
    maxHeight: "30px",
    direction: "ltr",
    padding: "10px",
    display: "flex",
    input: {
      textAlign: "left !important",
      fontSize: "12px",
    },
  },
}));

export default SearchInput;
